import * as Sentry from "@sentry/react";
import pjson from '../../package.json'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  release: pjson.version,
  environment: process.env.REACT_APP_PUBLIC_ENVIRONMENT,
  tracesSampleRate: 0.05,
  debug: false,
  replaysOnErrorSampleRate: 0.05,
  replaysSessionSampleRate: 0.1,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
})

